export function getFarmerId(): string | undefined {
  try {
    const profile = localStorage.getItem("profile");
    if (!profile) return undefined;

    const parsed = JSON.parse(profile);
    return parsed?.id;
  } catch (e) {
    console.error("Error parsing profile from localStorage", e);
    return undefined;
  }
}
